import { render } from "./password_reset.vue?vue&type=template&id=3a677309"
import script from "./password_reset.js?vue&type=script&lang=js"
export * from "./password_reset.js?vue&type=script&lang=js"

import "./password_reset.vue?vue&type=style&index=0&id=3a677309&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__